import { render, staticRenderFns } from "./AlegereEveniment.vue?vue&type=template&id=0616a7cd&scoped=true&"
import script from "./AlegereEveniment.ts?vue&type=script&lang=ts&"
export * from "./AlegereEveniment.ts?vue&type=script&lang=ts&"
import style0 from "./AlegereEveniment.vue?vue&type=style&index=0&id=0616a7cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0616a7cd",
  null
  
)

export default component.exports